"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteStatus = void 0;
/**
 * 用户注册完善状态
 */
var CompleteStatus;
(function (CompleteStatus) {
    CompleteStatus[CompleteStatus["UN_DONE"] = 0] = "UN_DONE";
    CompleteStatus[CompleteStatus["DONE"] = 1] = "DONE";
})(CompleteStatus = exports.CompleteStatus || (exports.CompleteStatus = {}));
